type ChipProps = {
  item: string;
  selected: boolean;
  onClick: (item: string) => void;
  color: string;
  strokeColor: string;
};

//색깔 있는 chip
//과거 업로드화면에서 색상 선택시에 사용됨
const Chip = (props: ChipProps) => {
  const { item, selected, onClick, color, strokeColor } = props;

  return (
    <div
      className={`chip ${selected ? "selected" : ""}`}
      onClick={() => {
        onClick(item);
      }}
    >
      <div
        className="chip-color"
        style={{
          background: color,
          borderColor: strokeColor,
        }}
      ></div>
      <span className={`${selected ? "body2-700 gray-900" : "body2-500 gray-500"}`}>
        {item}
      </span>
    </div>
  );
};

export { Chip };
